import React, { useContext, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { IApplicationContext } from 'interfaces/i-application-context-props'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import updateApplicationServices from 'services/updateApplicationServices'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import ErrorBox from 'components/message-boxes/error-box/ErrorBox'

import './Ppi.scss'
import { MarketingConsentCheckbox } from '../MarketingConsent/MarketingConsent'

export const PpiSe = () => {
	const { t } = useTranslation()
	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext
	)
	const { msp, dispatchMsp } = useContext(MspDispatchContext)
	const [gdprConsent, setGdprConsent] = useState<boolean>(false)
	const [loading, setLoading] = useState<boolean>(false)
	const [error, setError] = useState<boolean>(false)
	const [errorMsg, setErrorMsg] = useState<string>('')

	const updateDataAndContinue = async () => {
		setLoading(true)
		setError(false)
		try {
			await allowMarketing()
			dispatchMsp({
				type: MSP_ACTIONS.SET_INDEX,
				payload: {
					index: msp.index + 1,
				},
			})
		} catch (err) {
			console.log(err)
			setErrorMsg(t('ErrorMsg'))
			setError(true)
		} finally {
			setLoading(false)
		}
	}

	const allowMarketing = async () => {
		await updateApplicationServices
			.updateCustomerConsent(loanApplication.customerConsents!, t)
			.then((response) => {
				if (response === 200) {
					console.log('response ', response)
				}
			})
			.catch((error) => {
				console.error(error)
			})
	}

	return (
		<div className="payment-protection-insurance">
			{loading ? (
				<CircleSpinner />
			) : (
				<div className="ppi-section">
					<div>
						<MarketingConsentCheckbox
							allowMarketing={
								loanApplication.applicationData
									?.customerConsents.allowMarketing
							}
						/>
						<label className="checkbox-container mt-2">
							<input
								type="checkbox"
								name="gdprConsent"
								className={`required-step ${
									gdprConsent ? 'completed-step' : ''
								}`}
								onChange={() => setGdprConsent(!gdprConsent)}
								checked={gdprConsent}
							/>
							<span className="checkmark"></span>
							<p>
								<Trans t={t} i18nKey="GdprLabel">
									I confirm that I have read and understood
									the information about how TF Bank Nordic
									processes my personal data
									<a
										rel="noopener noreferrer"
										target="_blank"
										className="text-link link-darkgray"
										href="https://tfnordic.se/integritetspolicy">
										LINK
									</a>
								</Trans>
							</p>
						</label>
					</div>
					{error ? (
						<div className="error-box-container">
							<ErrorBox message={t('PpiError')} />
						</div>
					) : null}
				</div>
			)}
			{error && (
				<div className="error-box-container">
					<ErrorBox message={errorMsg} />
				</div>
			)}

			<div className="ppi-next-button">
				<button
					id="getPpiBtnSe"
					className="btn btn-primary"
					onClick={() => {
						setTimeout(() => {
							updateDataAndContinue()
						}, 400)
					}}
					disabled={!gdprConsent || loading}>
					{t('Next')}
				</button>
			</div>
		</div>
	)
}
